/**
 * Re-export shim. The ProgramPolicies View + its whole policy-editor subtree
 * were hoisted into `@solomon-apps/shared/src/widgets/yaas/programs` so
 * external consumers (the "+New Program" wiki doc) can render the bare Policies
 * section fixture-driven, with no wallet / RPC / orgApiFetch.
 *
 * `yaas-client` keeps importing it from this path unchanged. The View's
 * `program` prop is typed as the minimal `{ status }` subset, so ProgramDetail
 * can keep passing a real `Program` (a structural superset) straight through.
 *
 * @see packages/shared/src/widgets/yaas/programs/ProgramPolicies.tsx
 */
export {
    ProgramPolicies,
    type ProgramPoliciesProps
} from "@solomon-apps/shared/src/widgets/yaas/programs/ProgramPolicies";
